<!--杭州东杰定制看板-->
<template>
  <div class="kanban">
    <img src="./22.png" style="width: 100%;" alt="">
    <span class="son" @click="handleFullScreen"></span>
  </div>
</template>
<style scoped>
  .son {
    position: absolute;
    display: block;
    width: 40px;
    height: 40px;
    top: 36px;
    right: 25px;
    cursor: pointer;
  }

  .kanban {
    width: 100%;
    padding: 0 !important;
    position: relative;
  }

  #my_iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 0;
    background: #333;
    margin: 0px;
  }

  /*body {*/
  /*    overflow: hidden;*/
  /*    margin: 0px;*/
  /*}*/

  .left {
    position: absolute;
    z-index: 2;
    background-color: #000;
    padding: 1em;
    width: 400px;
  }

  #layer {
    width: 1px;
    height: 1px;

    z-index: 99;
    position: absolute;
    color: #fff;

  }

  #text {
    width: 100px;
    height: 100px;
    background: #00000066;
    position: relative;
    top: -120px;
    left: -50px;
    border: 2px solid #111;
    border-radius: 5px;
    padding: .5em;
  }
</style>
<script>
  import * as THREE from "three";
  import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";
  import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
  export default {
    data () {
      return {
        fullscreen: false,
        camera: null,
        scene: null,
        renderer: null,
        controls: null,
        mush: null,
        loader: null,
        mixer: null,
        clock: new THREE.Clock() 
      }
    },
    mounted () {
      // window.open('http://192.168.124.13:8080/#/url','_blank');
    },
    methods: {
      // 全屏事件
      handleFullScreen () {
        // 此处可根据获取节点进行区域全屏事件
        let element=document.getElementsByClassName('kanban')[0];
        if(this.fullscreen) {
          if(document.exitFullscreen) {
            document.exitFullscreen();
          } else if(document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if(document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if(document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          if(element.requestFullscreen) {
            element.requestFullscreen();
          } else if(element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if(element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if(element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
        this.fullscreen=!this.fullscreen;

      },

    }
  }
</script>